import { useEffect, useState } from "react";
import { api, formatINR } from "../lib/api";

export default function AdminCodForfeits() {
    const [items, setItems] = useState([]);
    const [totalPaise, setTotalPaise] = useState(0);

    useEffect(() => {
        api.get("/admin/cod-forfeits")
            .then(({ data }) => { setItems(data.items || []); setTotalPaise(data.totalPaise || 0); })
            .catch(() => { setItems([]); setTotalPaise(0); });
    }, []);

    return (
        <div data-testid="admin-cod-forfeits-page">
            <span className="label-eyebrow">Accounting</span>
            <h1 className="mt-2 font-display text-4xl text-inkDark">COD Forfeits</h1>
            <p className="mt-1 text-inkMuted">Advances forfeited due to customer-side cancellation on COD orders. Read-only accounting view.</p>

            <div className="mt-6 bg-beige rounded-2xl p-5 inline-block">
                <div className="label-eyebrow text-[10px]">Total forfeited</div>
                <div className="font-display text-3xl mt-1">{formatINR(totalPaise / 100)}</div>
                <div className="text-xs text-inkMuted mt-1">{items.length} orders</div>
            </div>

            <div className="mt-8 overflow-x-auto bg-ivory rounded-2xl border border-inkDark/5">
                <table className="w-full text-sm">
                    <thead className="bg-beige text-inkMuted">
                        <tr>
                            <th className="text-left px-4 py-3">Order</th>
                            <th className="text-left px-4 py-3">Customer</th>
                            <th className="text-right px-4 py-3">Grand total</th>
                            <th className="text-right px-4 py-3">Advance forfeited</th>
                            <th className="text-left px-4 py-3">Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((f) => (
                            <tr key={f.id} className="border-t border-inkDark/5">
                                <td className="px-4 py-3 font-mono text-xs">{f.orderId?.slice(0, 8)}…</td>
                                <td className="px-4 py-3">{f.userEmail}</td>
                                <td className="px-4 py-3 text-right">{formatINR(f.grandTotal)}</td>
                                <td className="px-4 py-3 text-right">{formatINR(f.advancePaise / 100)}</td>
                                <td className="px-4 py-3 text-xs text-inkMuted">{f.createdAt ? new Date(f.createdAt).toLocaleString() : ""}</td>
                            </tr>
                        ))}
                        {items.length === 0 ? <tr><td colSpan={5} className="px-4 py-10 text-center text-inkMuted">No forfeits yet.</td></tr> : null}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
